import { withEngagingURL } from '../../../decorators'
import { useGenericRequestHandler } from '../../../handlers/useGenericRequestHandler'
import type {
  AuthenticatedAuth,
  Conversation,
  Device,
  Entitlements,
  ErrorStatus,
  MoteStatus,
  UnauthenticatedAuth
} from '../../../models'

export interface CommonConversationMutationData {
  moteStatus: MoteStatus
  conversation: Conversation
  device: Device
}

export interface AuthenticatedConversationMutationData
  extends CommonConversationMutationData {
  auth: AuthenticatedAuth
  entitlements: Entitlements
}

export interface AnonymousConversationMutationData
  extends CommonConversationMutationData {
  auth: UnauthenticatedAuth
}

export type ConversationMutationData =
  | AuthenticatedConversationMutationData
  | AnonymousConversationMutationData

export type ConversationErrorStatus = ErrorStatus<
  { moteContext: string } | { visibilityContext: string }
>

export interface UseMoteConversationMutation {
  data: ConversationMutationData | null
  loading: boolean
  fetched: boolean
  error: any
  errorJson: ConversationErrorStatus | null
  mutate: (options?: {
    variables?: object
  }) => Promise<Omit<UseMoteConversationMutation, 'mutate'>>
  flush: () => void
}

export function useMoteConversationMutation(
  moteId: string,
  shouldPropagate403 = false
): UseMoteConversationMutation {
  const value = useGenericRequestHandler({
    route: `v1/m/conversation/${moteId}`,
    method: 'POST',
    options: {
      timeout: 25000,
      shouldPropagate403
    }
  })

  //@ts-expect-error
  return withEngagingURL(value)
}
